import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { PasswordResetRequest } from 'types/api'
import { BaseParams } from 'types/utils'

export function useCreateForgottenPassword() {
  const toast = useToast()
  const { t } = useTranslation('auth')
  const onError = useOnError()

  async function createForgottenPassword({
    body
  }: BaseParams<PasswordResetRequest, 'POST'>) {
    const res = await apiClient.post<undefined>(
      `${SNA_PREFIX}auth/password-reset`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: createForgottenPassword,
    onSuccess: () => {
      toast.success({ message: t('forgotPassword.successTitle') })
    },
    onError
  })
}
